import { makeStyles } from "@material-ui/core";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import { TheCycleverseTheme } from "src/theme";
import { commonColors } from "./data";
import { TableExplanation } from "./TableExplanation";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  holizontalLineContainer: {
    marginTop: "50px",
    marginBottom: "50px",
  },

  grayBorderBottom: {
    borderBottom: "1px solid #998F8F",
  },

  borderTopLeftBottom: {
    borderLeft: "1px solid #998F8F",
    borderTop: "1px solid #F2F2F0",
    borderBottom: "1px solid #F2F2F0",
  },

  borderBottomAndPadding: {
    borderBottom: "1px solid #F2F2F0",
    padding: "0 25px 10px 0",
  },

  graphAndTableContainer: {
    width: "fit-content",
    margin: "auto",
    padding: "50px 0",
  },

  blueText: {
    color: theme.blueTextColor,
  },

  greenText: {
    color: theme.greenColor,
  },

  orangeText: {
    color: theme.lightOrangeColor,
  },

  redText: {
    color: theme.darkOrangeColor,
  },

  tableDataPadding: {
    padding: "0 5px",
    textAlign: "center",
  },

  headerSpacing: {
    padding: "0 0 10px 5px",
  },

  otherHeaders: {
    padding: "10px 10px 10px 0",
  },

  tableDataContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
}));

const CalculatorTable = ({ results, field1, field5, display }) => {
  const classes = useStyles();
  const { lang, t } = useTranslation("ritzelRechner");

  const dispkayRedValueRaw1 = (index: number) => {
    return (
      (index > results[0].rows[2].row2.length - 5 && field5.includes("4")) ||
      (index > results[0].rows[2].row2.length - 4 && field5.split(" - ")[0] === "3") ||
      (index === results[0].rows[2].row2.length - 1 && field5.split(" - ")[0] === "1") ||
      (index > results[0].rows[2].row2.length - 3 && field5.split(" - ")[0] === "2")
    );
  };

  const dispkayRedValueRaw2 = (index: number) => {
    if (Number(field1) === 3) {
      return (
        ((index < 1 || index > results[0].rows[2].row2.length - 2) &&
          field5.split(" - ")[0] === "4" &&
          field5.split(" - ")[1] === "2") ||
        ((index < 2 || index > results[0].rows[2].row2.length - 3) &&
          field5.split(" - ")[0] === "4" &&
          field5.split(" - ")[1] === "4") ||
        ((index < 1 || index > results[0].rows[2].row2.length - 2) &&
          field5.split(" - ")[0] === "3" &&
          field5.split(" - ")[1] === "2") ||
        ((index < 1 || index > results[0].rows[2].row2.length - 2) &&
          field5.split(" - ")[0] === "2" &&
          field5.split(" - ")[1] === "2")
      );
    } else {
      return (
        (index > results[0].rows[2].row2.length - 5 && field5.split(" - ")[0] === "4") ||
        (index > results[0].rows[2].row2.length - 4 && field5.split(" - ")[0] === "3") ||
        (index > results[0].rows[2].row2.length - 3 && field5.split(" - ")[0] === "2") ||
        (index > results[0].rows[2].row2.length - 2 && field5.split(" - ")[0] === "1")
      );
    }
  };

  const dispkayRedValueRaw3 = (index: number) => {
    return (
      (index < 4 && field5.split(" - ")[0] === "4") ||
      (index < 3 && field5.split(" - ")[0] === "3") ||
      (index < 1 && field5.split(" - ")[0] === "1") ||
      (index < 2 && field5.split(" - ")[0] === "2")
    );
  };

  return (
    <>
      <div className={classes.graphAndTableContainer}>
        <table style={{ borderCollapse: "collapse", maxWidth: "800px" }}>
          <tbody>
            <tr>
              <td></td>
              <td></td>
              <td className={classes.headerSpacing} style={{ borderLeft: "1px solid #998F8F", width: "30px" }}>
                R
              </td>
              {results[0].R?.map((r) => (
                <td className={classes.headerSpacing} key={r} style={{ textAlign: "center" }}>
                  {r}
                </td>
              ))}
            </tr>
            <tr className={classes.grayBorderBottom}>
              <td className={classes.grayBorderBottom}></td>
              <td className={classes.grayBorderBottom}></td>
              <td
                style={{
                  borderBottom: "1px solid #998F8F",
                  borderLeft: "1px solid #998F8F",
                  width: "30px",
                }}
                className={classes.headerSpacing}
              >
                Anz
              </td>
              {results[0].Rx?.map((rx) => (
                <td
                  className={`${classes.tableDataPadding} ${classes.headerSpacing}`}
                  key={rx}
                  style={{ borderBottom: "1px solid #998F8F" }}
                >
                  {rx}
                </td>
              ))}
            </tr>

            <tr>
              <td className={classes.otherHeaders} style={{ borderBottom: "1px solid #F2F2F0" }}>
                K
              </td>
              <td className={classes.otherHeaders} style={{ borderBottom: "1px solid #F2F2F0", width: "30px" }}>
                Anz
              </td>
              <td style={{ borderLeft: "1px solid #998F8F" }}></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            {results[0].rows[1].row1 &&
            results[0].rows[1].row1.length &&
            results[0].rows[0]?.firstCells[Number(field1) - 3]?.length ? (
              <tr>
                <td className={classes.borderBottomAndPadding}>
                  {" "}
                  {results[0].rows[0]?.firstCells[Number(field1) - 3][0]}
                </td>
                <td className={classes.borderBottomAndPadding}>
                  {" "}
                  {results[0].rows[0]?.firstCells[Number(field1) - 3][1]}
                </td>

                <td className={classes.borderTopLeftBottom}></td>

                {results[0].rows[1].row1.map((cell, index) => (
                  <td className={classes.tableDataPadding} key={index} style={{ border: "1px solid #000" }}>
                    <div className={classes.tableDataContainer}>
                      <span
                        style={{
                          color: dispkayRedValueRaw1(index) ? commonColors["red"] : commonColors["blue"],
                        }}
                      >
                        {cell[0].toLocaleString(lang, { maximumFractionDigits: 2 })}
                      </span>
                      <span
                        style={{
                          color: dispkayRedValueRaw1(index) ? commonColors["orange"] : commonColors["green"],
                          marginLeft: "5px",
                        }}
                      >
                        {cell[1].toLocaleString(lang, { maximumFractionDigits: 2 })}
                      </span>
                    </div>
                  </td>
                ))}
              </tr>
            ) : null}

            {results[0].rows[2].row2 &&
            results[0].rows[2].row2.length &&
            results[0].rows[0]?.firstCells[Number(field1) - 2]?.length ? (
              <tr>
                <td className={classes.borderBottomAndPadding}>
                  {" "}
                  {results[0].rows[0]?.firstCells[Number(field1) - 2][0]}
                </td>
                <td className={classes.borderBottomAndPadding}>
                  {" "}
                  {results[0].rows[0]?.firstCells[Number(field1) - 2][1]}
                </td>

                <td className={classes.borderTopLeftBottom}></td>

                {results[0].rows[2].row2.map((cell, index) => (
                  <td className={classes.tableDataPadding} key={index} style={{ border: "1px solid #000" }}>
                    <div className={classes.tableDataContainer}>
                      <span
                        style={{
                          color: dispkayRedValueRaw2(index) ? commonColors["red"] : commonColors["blue"],
                        }}
                      >
                        {cell[0].toLocaleString(lang, { maximumFractionDigits: 2 })}
                      </span>
                      <span
                        style={{
                          color: dispkayRedValueRaw2(index) ? commonColors["orange"] : commonColors["green"],
                          marginLeft: "5px",
                        }}
                      >
                        {cell[1].toLocaleString(lang, { maximumFractionDigits: 2 })}
                      </span>
                    </div>
                  </td>
                ))}
              </tr>
            ) : null}

            {results[0].rows[3].row3 &&
            results[0].rows[3].row3.length &&
            results[0].rows[0]?.firstCells[Number(field1) - 1]?.length ? (
              <tr>
                <td className={classes.borderBottomAndPadding}>
                  {" "}
                  {results[0].rows[0]?.firstCells[Number(field1) - 1][0]}
                </td>
                <td className={classes.borderBottomAndPadding}>
                  {" "}
                  {results[0].rows[0]?.firstCells[Number(field1) - 1][1]}
                </td>

                <td className={classes.borderTopLeftBottom}></td>

                {results[0].rows[3].row3.map((cell, index) => (
                  <td className={classes.tableDataPadding} key={index} style={{ border: "1px solid #000" }}>
                    <div className={classes.tableDataContainer}>
                      <span
                        style={{
                          color: dispkayRedValueRaw3(index) ? commonColors["red"] : commonColors["blue"],
                        }}
                      >
                        {cell[0].toLocaleString(lang, { maximumFractionDigits: 2 })}
                      </span>
                      <span
                        style={{
                          color: dispkayRedValueRaw3(index) ? commonColors["orange"] : commonColors["green"],
                          marginLeft: "5px",
                        }}
                      >
                        {cell[1].toLocaleString(lang, { maximumFractionDigits: 2 })}
                      </span>
                    </div>
                  </td>
                ))}
              </tr>
            ) : null}
          </tbody>
        </table>

        {<TableExplanation display={display} field1={field1} />}
      </div>
    </>
  );
};

export default CalculatorTable;
